export default __webpack_public_path__ + "static/media/nft-23.002ae18a.png";